import React from 'react';

class Dashboard extends React.Component {
    componentDidMount() {
        this.props.updateBreadcrumbs(['Dashboard']);
    }
    render() {
        return <div />;
    }
}

export default Dashboard;
